/* @flow */
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Datepickers from './dates/datepickers.js';
import './dates.css';

class Dates extends Component {

  constructor(props) {
    super(props);
    this.state = { custom: this.props.dates.custom };
    this.setCustom = this.setCustom.bind(this);
  }

  setCustom(e) {
    e.preventDefault();
    this.setState({ custom: true });
  }

  render() {
    let selectedFlag = (this.state.custom ? 'c' : String(this.props.dates.days));
    return (
      <section className="Dates">
        <label>Show stats for:</label>
        <ul className="buttons">
          <li className={selectedFlag === '1' ? 'selected' : 'unselected'}>
            <Link to={`${ this.props.location.pathname }#days=1`} onClick={(e) => this.props.parametersChanged(e)}>
              <p>Last</p><p>24 hours</p>
            </Link>
          </li>
          <li className={selectedFlag === '7' ? 'selected' : 'unselected'}>
            <Link to={`${ this.props.location.pathname }#days=7`} onClick={(e) => this.props.parametersChanged(e)}>
              <p>Last</p><p>7 days</p>
            </Link>
          </li>
          <li className={selectedFlag === '30' ? 'selected' : 'unselected'}>
            <Link to={`${ this.props.location.pathname }`} onClick={(e) => this.props.parametersChanged(e)}>
              <p>Last</p><p>30 days</p>
            </Link>
          </li>
          <li className={selectedFlag === 'c' ? 'selected' : 'unselected'}>
            <a className="custom" href="stats/custom" onClick={this.setCustom}>
              Custom
            </a>
          </li>
        </ul>
        <Datepickers
          custom={this.state.custom}
          dateFrom={this.props.dates.from}
          dateTo={this.props.dates.to}
          parametersChanged={this.props.parametersChanged}
          location={this.props.location}
        />
      </section>
    );
  }
  
}

export default Dates;



// WEBPACK FOOTER //
// ./src/app/stats/container/dates.js